import React from 'react'

const SubTitle = (props) => {
  return (
    <p className='countdown__sub-title'>{props.subTitle}</p>
  )
}

export default SubTitle
